import { kebabCase } from 'lodash';
import * as Pages from 'pages';

export const ROUTES = Object.keys(Pages).map(page => {
	return { Page: (Pages as any)[page] as React.FC, path: kebabCase(page) };
});

export type PageDefinition = Readonly<(typeof ROUTES)[0]>;
